export default __webpack_public_path__ + "src/images/packages/lachataigne-farm/92f650ecf69b130c7953010ec5e724a2-1.jpg";